/**
 * IMPORTANT! this method doesn't validate the UUID strongly. It only verify the id is valid using length heuristic.
 * @return {*}
 */
export default (potentialId => {
  return !!(potentialId && potentialId.length >= 30);
});
//# sourceMappingURL=isValidUUID.js.map